import { twMerge } from 'tailwind-merge'

import { SliderLayer, type SliderLayerProps } from '@fv/client-components'

export type CarrierSliderProps = SliderLayerProps & {
  flush?: boolean
}

const panelClassName =
  'flex flex-col bg-[#fafafa] shadow-[-10px_0_30px_rgb(0_0_0_/_18%)]'

export const CarrierSlider = ({
  children,
  className,
  flush = false,
  ...props
}: CarrierSliderProps) => (
  <SliderLayer
    {...props}
    className={twMerge(panelClassName, !flush && 'p-6', className)}
  >
    {children}
  </SliderLayer>
)
